import { FC } from "react";
import styles from "./index.module.scss";

const Item = ({
  children,
  onClick,
}: {
  children: string;
  onClick: (text: string) => void;
}) => {
  return (
    <div className={styles.item} onClick={() => onClick(children)}>
      {children}
      <svg
        width="14"
        height="9"
        viewBox="0 0 14 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.6125 3.9375H0.625V5.35417H10.6125L8.41667 7.55L9.40833 8.54167L13.3042 4.64583L9.47917 0.75L8.4875 1.74167L10.6125 3.9375Z"
          fill="#444"
        />
      </svg>
    </div>
  );
};

interface ChatEmptyProps {
  onSelect: (text: string) => void;
}

const ChatEmpty: FC<ChatEmptyProps> = ({ onSelect }) => {
  return (
    <div className={styles.empty}>
      <div className={styles.title}>编程答疑</div>
      <div className={styles.content}>
        <div className={styles.line}>
          <Item onClick={(text) => onSelect(text)}>
            如何本地安装 Python 环境
          </Item>
          <Item onClick={(text) => onSelect(text)}>
            Python 二分查找代码示例
          </Item>
        </div>
        <div className={styles.line}>
          <Item onClick={(text) => onSelect(text)}>
            如何用 Python 写九九乘法表
          </Item>
          <Item onClick={(text) => onSelect(text)}>Python 画个 ♥️ 程序</Item>
        </div>
        <div className={styles.line}>
          <Item onClick={(text) => onSelect(text)}>写段 Python 冒泡排序</Item>
          <Item onClick={(text) => onSelect(text)}>
            怎样成为 Python 编程高手
          </Item>
        </div>
      </div>
    </div>
  );
};

export default ChatEmpty;
